import { render } from "./ReportEditPage.vue?vue&type=template&id=5f56f342"
import script from "./ReportEditPage.vue?vue&type=script&lang=js"
export * from "./ReportEditPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__